import UploadHistoricalData from "routes/masiveOperations/historicalData/UploadHistoricalData";
import CheckStatusPage from "routes/home/CheckStatusPage";
import FirstContainers from "routes/firstContainerRegistry";
import ContainersPage from "routes/containers/ContainersPage";
import Users from "routes/users";
import DispensarySale from "routes/dispensarySale";
import DispensariesScreen from "routes/dispensaries/DispensariesScreen";
import Printer from "routes/printer";
import Backups from "routes/backups";
import Alerts from "routes/alerts";
import DictumForm from "routes/dictums/components/DictumForm";
import OperationCertificates from "routes/certificates/page";
import OutputEmailConfig from "routes/configurationOutputEmail";
import HealthInformation from "routes/healthApplication";
import CorruptedDataVisualizer from "routes/corruptedDataVisualizer";
import FirstWarehouses from "routes/firstWarehouseRegistry";
import Warehouses from "routes/wareHouse";
import Subscriptions from "routes/subscriptions";
import UpsertDistributionPoint from "routes/distributionPoints/UpsertDistributionPoint";
import StockControl from "routes/stockControl/StockControl";
import DistributionPointsScreen from "routes/distributionPoints/DistributionPointsScreen";
import UploadCFDIs from "routes/masiveOperations/CFDIs/UploadCFDIs";
import UploadJsonSATReport from "routes/masiveOperations/SATReport/UploadJsonSATReport";
import ReceptionScreen from "routes/receptions/ReceptionScreen";
import DictumsScreen from "routes/dictums/DictumsScreen";
import ComplementsScreen from "routes/cfdiComplements/ComplementsScreen";
import TraspasosScreen from "routes/Traspasos/TraspasosScreen";
import HoseBySaleScreen from "routes/hoseSale/HoseBySaleScreen";
import JsonReportsScreen from "routes/jsonReport/JsonReportsScreen";
import UnRelatedCFDIsScreen from "routes/cfdiComplements/UnRelatedCFDIsScreen";
import AppConfigurationScreen from "routes/configurationApplication/AppConfigurationScreen";
import FirstAppConfigurationWrapper from "routes/firstConfigApplication/FirstAppConfiguration";
import DashboardScreen from "routes/dashboard/DashboardScreen";
import RegEntradaScreen from "routes/entryVolumeMeasurer/RegEntradaScreen";

import {
  BACKUP_PERMISSION,
  DISPENSARY_PERMISSION,
  EVENTS_PERMISSION,
  EVM_PERMISSION,
  INVENTORY_CONTROL_PERMISSION,
  PRINTER_PERMISSION,
  REGISTER_PERMISSION,
  SALES_PERMISSION,
  SALE_RESUME_PERMISSION,
  USERS_PERMISSION,
  PERMISSIONS,
  EVM_DETAILS,
  DICTUM,
  INITIAL_CONTAINER,
  OPERATION_CERTIFICATE,
  CONFIG_APPLICATION,
  FIRST_CONFIG_APPLICATION,
  CORRUPTED_DATA_VISUALIZER_PERMISSION,
  INITIAL_WAREHOUSE_PERMISSIONS,
  WAREHOUSE_PERMISSIONS,
  DISTRIBUTION_POINT_PERMISSIONS,
  DASHBOARD_PERMISSION,
} from "../../../../security/permissions";
import { MenuItem } from "./menuTypes";
import EventPage from "routes/logbook/EventPage";
import DownloadJsonReportsScreen from "routes/masiveOperations/downloadJsonReport/DownloadJsonReportsScreen";
import VolumeMeasurementsScreen from "routes/volumeMeasurerRegistries/components/VolumeMeasurementsScreen";

/** ORdern en que se desea aparezcan las secciones*/
export const SECTION_ORDER = [
  "Configuración Inicial",
  "Puntos de Distribución",
  "General",
];

const menuItems: MenuItem[] = [
  // ── Hidden root ────────────────────────────────────────────────────────────
  {
    section: "Control Volumétrico",
    key: DISPENSARY_PERMISSION,
    path: "/",
    component: CheckStatusPage,
    icon: "setting",
    title: "Aplicación",
    submenu: false,
    show: false,
  },

  // ── Configuración Inicial ──────────────────────────────────────────────────
  {
    section: "Configuración Inicial",
    key: FIRST_CONFIG_APPLICATION,
    path: "/FirstConfigApplication",
    component: FirstAppConfigurationWrapper,
    icon: "setting",
    title: "Configuración de aplicación",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: REGISTER_PERMISSION,
    path: "/distributionPoints/new",
    component: UpsertDistributionPoint,
    icon: "form",
    title: "Registro",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: INITIAL_WAREHOUSE_PERMISSIONS,
    path: "/firstWareHouseRegistry",
    component: FirstWarehouses,
    icon: "container",
    title: "Almacenes Iniciales",
    submenu: false,
    show: true,
  },
  {
    section: "Configuración Inicial",
    key: INITIAL_CONTAINER,
    path: "/firstContainerRegistry",
    component: FirstContainers,
    icon: "container",
    title: "Contenedores Iniciales",
    submenu: false,
    show: true,
  },

  // ── Puntos de Distribución ───────────────────────────
  {
    section: "Puntos de Distribución",
    key: WAREHOUSE_PERMISSIONS,
    path: "/wareHouse",
    component: Warehouses,
    icon: "bank",
    title: "Almacenes",
    submenu: false,
    show: true,
  },
  {
    section: "Puntos de Distribución",
    key: DISPENSARY_PERMISSION,
    path: "/containers",
    component: ContainersPage,
    icon: "container",
    title: "Contenedores",
    submenu: false,
    show: true,
  },
  {
    section: "Puntos de Distribución",
    key: EVM_PERMISSION,
    path: "/entryVolumeMeasurer",
    component: RegEntradaScreen,
    title: "Registro de entrada",
    icon: "dashboard",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: DISPENSARY_PERMISSION,
    path: "/dispensaries",
    component: DispensariesScreen,
    icon: "sliders",
    title: "Equipos",
    submenu: true,
    show: true,
    items: [
      {
        key: DISPENSARY_PERMISSION,
        path: "/dispensaries",
        component: DispensariesScreen,
        title: "Dispensarios",
      },
      {
        key: EVM_PERMISSION,
        path: "/entryVolumeMeasurer",
        component: RegEntradaScreen,
        title: "Registro de entrada",
      },
    ],
  },
  {
    section: "Puntos de Distribución",
    key: SALES_PERMISSION,
    path: "/hoseSale",
    component: HoseBySaleScreen,
    title: "Ventas",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: EVM_DETAILS,
    path: "/volumeMeasurerRegistries",
    component: VolumeMeasurementsScreen,
    icon: "snippets",
    title: "Mediciones de nivel",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: EVM_DETAILS,
    path: "/traspasos",
    component: TraspasosScreen,
    icon: "dashboard",
    title: "Traspasos",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: SALES_PERMISSION,
    path: "/receptions",
    component: ReceptionScreen,
    icon: "dashboard",
    title: "Reportes",
    submenu: true,
    show: true,
    items: [
      {
        key: EVM_DETAILS,
        path: "/receptions",
        component: ReceptionScreen,
        title: "Recepciones",
      },
      {
        key: EVM_DETAILS,
        path: "/traspasos",
        component: TraspasosScreen,
        title: "Traspasos",
      },
      {
        key: SALES_PERMISSION,
        path: "/hoseSale",
        component: HoseBySaleScreen,
        title: "Ventas",
      },
      {
        key: EVM_DETAILS,
        path: "/volumeMeasurerRegistries",
        component: VolumeMeasurementsScreen,
        title: "Mediciones de volumen",
      },
    ],
  },
  {
    section: "Puntos de Distribución",
    key: DICTUM,
    path: "/dictums",
    component: DictumsScreen,
    icon: "snippets",
    title: "Dictamenes",
    submenu: false,
    show: true,
  },
  {
    section: "Puntos de Distribución",
    key: DICTUM,
    path: "/dictum/:id",
    component: DictumForm as React.ComponentType<unknown>,
    title: "Dictamenes",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: OPERATION_CERTIFICATE,
    path: "/operationCertificates",
    component: OperationCertificates as React.ComponentType<unknown>,
    icon: "safety-certificate",
    title: "Certificados",
    submenu: false,
    show: true,
  },
  {
    section: "Puntos de Distribución",
    key: INVENTORY_CONTROL_PERMISSION,
    path: "/jsonReports",
    component: JsonReportsScreen,
    title: "Reportes Json",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: INVENTORY_CONTROL_PERMISSION,
    path: "/stockControl",
    component: StockControl,
    icon: "calculator",
    title: "Control de existencias",
    submenu: true,
    show: true,
    items: [
      {
        key: INVENTORY_CONTROL_PERMISSION,
        path: "/stockControl",
        component: StockControl,
        title: "Control de existencias",
      },
      {
        key: INVENTORY_CONTROL_PERMISSION,
        path: "/jsonReports",
        component: JsonReportsScreen,
        title: "Reportes Json",
      },
    ],
  },
  {
    section: "Puntos de Distribución",
    key: EVENTS_PERMISSION,
    path: "/logbook",
    component: EventPage,
    icon: "book",
    title: "Bitácora",
    submenu: true,
    show: true,
    items: [
      {
        key: EVENTS_PERMISSION,
        path: "/logbook",
        component: EventPage,
        title: "Eventos y alarmas",
      },
      {
        key: CORRUPTED_DATA_VISUALIZER_PERMISSION,
        path: "/corruptedDataVisualizer",
        component: CorruptedDataVisualizer,
        title: "Descargas fallidas",
      },
    ],
  },

  // ── General ────────────────────────────────────────────────────────────────
  {
    section: "General",
    key: DASHBOARD_PERMISSION,
    path: "/dashboard",
    component: DashboardScreen,
    icon: "home",
    title: "Dashboard",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/",
    component: DistributionPointsScreen,
    icon: "bank",
    title: "Puntos de Distribución",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/distributionPoints",
    component: DistributionPointsScreen,
    icon: "bank",
    title: "Puntos de Distribución",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: PERMISSIONS,
    path: "/subscription",
    component: Subscriptions,
    icon: "desktop",
    title: "Suscripción",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadCfdis",
    component: UploadCFDIs,
    icon: "bank",
    title: "Carga CFDIs",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadJsonSATReport",
    component: UploadJsonSATReport,
    title: "Cargar reporte Excel SAT",
    icon: "bank",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/uploadHistoricalData",
    component: UploadHistoricalData,
    icon: "sync",
    title: "Operaciones Masivas",
    submenu: true,
    show: true,
    items: [
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadHistoricalData",
        component: UploadHistoricalData,
        title: "Carga Histórica",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadCfdis",
        component: UploadCFDIs,
        title: "Carga CFDIs",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/uploadJsonSATReport",
        component: UploadJsonSATReport,
        title: "Cargar reporte Excel SAT",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/cfdis",
        component: UnRelatedCFDIsScreen,
        title: "CFDIs Descargados",
      },
      {
        key: DISTRIBUTION_POINT_PERMISSIONS,
        path: "/downloadJson",
        component: DownloadJsonReportsScreen,
        title: "Descarga de Json",
      },
    ],
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/cfdis",
    component: UnRelatedCFDIsScreen,
    icon: "fileSync",
    title: "CFDIs Descargados",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: DISTRIBUTION_POINT_PERMISSIONS,
    path: "/downloadJson",
    component: DownloadJsonReportsScreen,
    icon: "fileSync",
    title: "Descarga de Json",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: PRINTER_PERMISSION,
    path: "/printer",
    component: Printer,
    icon: "printer",
    title: "Impresora",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: BACKUP_PERMISSION,
    path: "/backups",
    component: Backups,
    icon: "save",
    title: "Respaldos",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: "alerts",
    path: "/alerts",
    component: Alerts,
    title: "Alertas",
    icon: "alert",
    submenu: false,
    show: true,
  },
  {
    section: "General",
    key: USERS_PERMISSION,
    path: "/users",
    component: Users,
    icon: "team",
    title: "Usuarios",
    submenu: false,
    show: true,
  },

  {
    section: "General",
    key: PERMISSIONS,
    path: "/healthApplication",
    component: HealthInformation,
    icon: "dashboard",
    title: "Estatus de aplicacíon",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: CONFIG_APPLICATION,
    path: "/configurationOutputEmail",
    component: OutputEmailConfig,
    icon: "mail",
    title: "Correo de salida",
    submenu: false,
    show: false,
  },
  {
    section: "General",
    key: CONFIG_APPLICATION,
    path: "/configurationApplication",
    component: AppConfigurationScreen,
    icon: "setting",
    title: "Configuración",
    submenu: true,
    show: true,
    items: [
      {
        key: CONFIG_APPLICATION,
        path: "/configurationApplication",
        component: AppConfigurationScreen,
        title: "Configuración",
      },
      {
        key: CONFIG_APPLICATION,
        path: "/configurationOutputEmail",
        component: OutputEmailConfig,
        title: "Correo de salida",
      },
      {
        key: PERMISSIONS,
        path: "/healthApplication",
        component: HealthInformation,
        title: "Estatus de aplicación",
      },
      {
        key: PERMISSIONS,
        path: "/subscription",
        component: Subscriptions,
        icon: "desktop",
        title: "Suscripción",
      },
    ],
  },

  // ── Hidden items sin sección ───────────────────────────────────────────────
  {
    key: INITIAL_WAREHOUSE_PERMISSIONS,
    path: "/distributionPoints/new",
    component: UpsertDistributionPoint,
    icon: "bank",
    title: "Nueva Instalación",
    submenu: false,
    show: false,
  },
  {
    section: "Puntos de Distribución",
    key: SALES_PERMISSION,
    path: "/complement/",
    component: ComplementsScreen,
    icon: "dashboard",
    title: "Complemento",
    submenu: false,
    show: false,
  },
  {
    key: SALE_RESUME_PERMISSION,
    path: "/dispensarySale",
    component: DispensarySale,
    title: "DispensarySale",
    submenu: false,
    show: false,
  },
  {
    key: SALES_PERMISSION,
    path: "/hoseSale",
    component: HoseBySaleScreen,
    title: "HoseSale",
    submenu: false,
    show: false,
  },
  {
    key: EVM_DETAILS,
    path: "/volumeMeasurerRegistries",
    component: VolumeMeasurementsScreen,
    icon: "snippets",
    title: "Mediciones de nivel",
    submenu: false,
    show: false,
  },
  {
    key: EVM_DETAILS,
    path: "/traspasos",
    component: TraspasosScreen,
    icon: "dashboard",
    title: "Traspasos",
    submenu: false,
    show: false,
  },
  {
    key: EVENTS_PERMISSION,
    path: "/corruptedDataVisualizer",
    component: CorruptedDataVisualizer,
    icon: "book",
    title: "Descargas fallidas",
    submenu: false,
    show: false,
  },
];

export const getMenu = (
  permissions: Record<string, { read: boolean }> = {},
  providerDataOrigin?: "G4S" | "EXTERNAL" | "UNKNOWN",
): MenuItem[] => {
  return menuItems.filter((item) => {
    if (!permissions[item.key] || permissions[item.key].read !== true) {
      return false;
    }

    if (providerDataOrigin === "EXTERNAL") {
      if (item.submenu && item.items) {
        item.items = item.items.filter(
          (subItem) =>
            !(
              subItem.path === "/uploadHistoricalData" &&
              subItem.title === "Carga Histórica"
            ),
        );
      }
    }

    return true;
  });
};
